import { Send } from 'lucide-react'
import React from 'react'

interface IChatMessageInputProps {
  showTypeCheckOverlay: boolean
  textareaRef: React.RefObject<HTMLTextAreaElement>
  message: string
  setMessage: (message: string) => void
  handleKeyPress: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
  handleSendMessage: () => void
  isSendButtonActive: boolean
  placeholderText: string
  buttonState?: 'send' | 'stop'
  isChatMainPage?: boolean
}

const ChatMessageInput = ({
  showTypeCheckOverlay,
  textareaRef,
  message,
  setMessage,
  handleKeyPress,
  handleSendMessage,
  isSendButtonActive,
  placeholderText,
  buttonState = 'send',
  isChatMainPage = false
}: IChatMessageInputProps) => {
  return (
    <div
      className={` ${isChatMainPage ? 'fixed bottom-24 left-4 right-4 z-10' : ''} ${showTypeCheckOverlay ? 'blur-sm pointer-events-none' : 'z-40'}`}
    >
      <div className='bg-white rounded-2xl border border-gray-200 shadow-lg p-1'>
        <div className='flex items-center gap-2'>
          <textarea
            ref={textareaRef}
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholderText}
            className='flex-1 resize-none border-none outline-none text-sm placeholder-gray-400 bg-transparent min-h-[16px] max-h-[64px] py-0.5 px-2'
            rows={1}
            style={{ height: 'auto', minHeight: '16px' }}
            onInput={e => {
              const target = e.target as HTMLTextAreaElement
              target.style.height = 'auto'
              target.style.height = Math.min(target.scrollHeight, 64) + 'px'
            }}
          />
          <button
            onClick={handleSendMessage}
            disabled={!isSendButtonActive || buttonState === 'stop'}
            className={`p-2 rounded-full transition-all flex items-center justify-center ${
              isSendButtonActive && buttonState === 'send'
                ? 'bg-gradient-to-r from-amber-400 to-amber-600 text-white hover:from-amber-500 hover:to-amber-700 shadow-sm'
                : 'bg-gray-200 text-gray-400'
            }`}
            style={{ width: '32px', height: '32px' }}
          >
            <Send className='w-4 h-4' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChatMessageInput
